// import * as ReactGA from "react-ga";

export default (_request, _options, response) => {
  const url = new URL(response.url || _request.url);
  let uri = url.pathname
    .replace(/^\//, "") // remove first /
    .replace(/^ajax\//, "") // remove ajax/
    .replace(/\.php/, ""); // remove .php

  if (excluded.includes(uri)) {
    return;
  }
  // always put a / on start
  uri = `/${uri}`;
  // response 200
  if (response.ok) {
    if (mappingUriLabel[uri]) {
      // ReactGA.pageview(uri, [], mappingUriLabel[uri]);
    } else {
      // track "unknown" uri
      // ReactGA.event({
      //   category: "Navigation",
      //   action: uri,
      //   label: "Unknown URI",
      //   value: 404
      // });
    }
  } else {
    // track response on error
    // ReactGA.event({
    //   category: "Error",
    //   action: uri,
    //   label: response.statusText,
    //   value: response.status
    // });
  }
};

const mappingUriLabel = {
  "/widget_liste_categorie": "Liste des catégories",
  "/get_question_react": `Récupération d'une question`,
  "/widget_liste_profession": `Liste des professions`,
  "/widget_liste_type_rdv": `Les motifs des rendez-vous`,
  "/liste_lieux": `Liste des lieux`,
  "/widget_widget_liste_praticien": `Liste des praticiens`,
  "/nb_personne": `Nombre de personne`,
  "/rdv_disponible_calendar_ajax": `Rendez-vous disponibles`,
  "/connexion_widget": `Connexion widget`,
  "/recap_rdv_ajax": `Récapitulatif`,
  "/inscription_widget_ajax": `Inscription`
};

const excluded = [
  "ReactWidget/config",
  "cache_ajax/faq_widget",
  "verif_info_user",
  "sequence_type_rdv",
  "validation_rdv",
  "get_user_liste_complete_ajax",
  "modification_liste_user_rdv",
  "enregistrement_rdv"
];
